// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__sU_E0","content":"styles_content__SEzKN","selectAll":"styles_selectAll__1QtoY"};